import React from 'react'
import { useRef } from 'react'
import logo from './nukhbaLogo1.png'
import Cart from './cart'
import { useContext, useState } from 'react'
import NoteContext from '../context/notes/noteContext'
import { Link, useLoaderData, useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

export default function Navbar() {
    const context = useContext(NoteContext)
    const location = useLocation()
    const {getCategories, openRef, country, setProducts, setnavLoader, categoriesRef, categories, setCategories, setMySpace, pageRef, ref, openCart, fetchCart, mainLoader, adminView, setAdminView, modalIsOpen, setMainLoader } = context




    useEffect(() => {
        getCategories()
    }, [])


    // let newCategories = categories.filter((e)=>{return e._id=="6433332d10b9054a792b64ef"})   


    let anotherCategory = []
    anotherCategory = categories
    const anotherArray = anotherCategory.filter((e) => { return e._id == "6433332d10b9054a792b64ef" })
    const array = categories.filter((e) => { return e._id !== "6433332d10b9054a792b64ef" })
    let xyzCategory = []
    xyzCategory = [...anotherArray, ...array]

    const finalCategory = xyzCategory.filter((e)=>{return !e.firstHeading.includes("*")})




    // console.log(categories)




    const history = useNavigate()
    const refer = useRef(null)

    const color = "#212427"
    const [blur, setBlur] = useState(false)
    const date = 1678538895

    useEffect(() => {
        setnavLoader(true)
    }, [location.pathname])




    if (!mainLoader) {
        setTimeout(() => {
            setnavLoader(false)
        }, 1000);
    }


    // if(navLoader){
    //     document.body.style.overflow = "hidden"
    // }
    // else{   
    //     document.body.style.overflowY = "hidden"
    //     document.body.style.overflowX = "hidden"

    // }


    // className={`${!navLoader && 'fixed-top' } modal-open ${!blur&&'blur'}`}>

    return (
        <div style={{ zIndex: modalIsOpen ? '0' : '999999999', backgroundColor: '#ffffff' }}
            className={` modal-open ${!blur && 'blur'}`}>
            {adminView && <div style={{ backgroundColor: '#f88234' }} className='d-flex justify-content-center'>
                <div className="d-flex my-2">
                    <p className='pt-2 mx-2' style={{ color: 'white' }} >Admin View Activated</p>
                    <button onClick={() => { localStorage.removeItem('auth-token'); history('/admin'); setAdminView(false) }} style={{ color: 'white', border: `1px solid white` }} className="btn">Logout</button>
                </div>
            </div>}

            <nav className="navbar navbar-expand-lg bg-body-tertiary" style={{ borderBottom: `1px solid ${color}` }}>

                {window.innerWidth < 992 ? <div className="container-fluid">
                    <div>

                        <button ref={categoriesRef} onClick={() => setBlur(true)} className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-placement="right" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
                            <i style={{ color: color }} className="fa fa-bars" aria-hidden={true}></i>
                        </button>
                    </div>
                    <div>
                        <Link onClick={() => setMySpace(10)} className="navbar-brand" to='/' style={{ color: color,transform:"scale(1.4)" }}>
                            <img src={logo} alt="Logo" width="40"  className="mx-2 d-inline-block align-text-top" />
                        
                        </Link>
                    </div>
                    <div>

                        <ul className="mynavbar-nav me-auto mb-2 mb-lg-0">




                            <li className="nav-item">
                                <a style={{ cursor: 'pointer' }} onClick={() => { openCart(); fetchCart() }} className="nav-link">
                                    <i style={{ fontSize: "25px", color: color }} className="fa fa-shopping-cart" aria-hidden={true}></i>

                                </a>

                            </li>


                        </ul>



                    </div>
                    <div style={{ height: '100%', backgroundColor: 'rgba(0,0,0,0)', backdropFilter: 'blur(15px)' }} className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                        <div className="offcanvas-header" style={{}}>
                            <div className="d-flex justify-content-end">
                                <div>
                                    <button onClick={() => setBlur(false)} ref={refer} style={{ color: '#ffffff' }} type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close">
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="offcanvas-body" style={{}}>
                            <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                                <form className="d-flex" role="search">
                                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">

                                        {window.innerWidth < 992 && <>
                                            {finalCategory.map((e) => {
                                                return <li className="nav-item">
                                                    <Link style={{ color: '#ffffff', fontSize: "30px" }} className="nav-link active" aria-current="page" to={`categories/${e._id}`} onClick={() => { refer.current.click() }}>{e.mainHeading}</Link>
                                                </li>
                                            })}


                                        </>}



                                    </ul>
                                </form>
                            </ul>

                        </div>
                        <div className="offcanvas-footer" style={{ borderTop: `1px solid ${'#ffffff'}` }}>
                            <ul className="mynavbar-nav me-auto mb-2 mb-lg-0 py-3 px-2">
                                <li className="nav-item mx-2 ">

                                    <a target="_blank" href="https://www.instagram.com/nukhba.shop/" style={{ cursor: 'pointer' }} className="nav-link">
                                        <i style={{ fontSize: "25px", color: '#ffffff' }} className="fa fa-instagram" aria-hidden={true}></i>

                                    </a>

                                </li>
                                <li className="nav-item mx-2">
                                    <a target="_blank" href="https://www.facebook.com/nukhbapk" style={{ cursor: 'pointer' }} className="nav-link">
                                        <i style={{ fontSize: "25px", color: '#ffffff' }} className="fa fa-facebook-official" aria-hidden={true}></i>

                                    </a>

                                </li>
                                <li className="nav-item">
                                        <a onClick={() => openRef.current.click()} style={{ cursor: 'pointer' }} className="nav-link">

                                            <img src={country == "Pakistan" ? "https://www.junaidjamshed.com/static/version1698317217/frontend/Rltsquare/junaidjamshed/en_US/Magento_Theme/images/pak-flag.png" : "https://upload.wikimedia.org/wikipedia/commons/0/0d/Flag_of_Saudi_Arabia.svg"} id="myBtn" alt="image-icon" width="30" >

                                            </img>

                                        </a>

                                    </li>
                            </ul>
                        </div>
                    </div>
                </div> :
                    <div className="container-fluid" >
                        <div>
                            <ul className="navbar-nav me-auto mb-2 mb-lg-0">


                                <li className="nav-item">
                                    <a target="_blank" href="https://www.instagram.com/nukhba.shop/" style={{ cursor: 'pointer' }} className="nav-link">
                                        <i style={{ fontSize: "25px", color: color }} className="fa fa-instagram" aria-hidden={true}></i>

                                    </a>

                                </li>
                                <li className="nav-item">
                                    <a target="_blank" href="https://www.facebook.com/nukhbapk" style={{ cursor: 'pointer' }} className="nav-link">
                                        <i style={{ fontSize: "25px", color: color }} className="fa fa-facebook-official" aria-hidden={true}></i>

                                    </a>

                                </li>


                            </ul>
                        </div>
                        <div>
                            <Link className="navbar-brand" to='/' style={{ color: color,transform:"scale(1.4)" }}>
                                <img src={logo} alt="Logo" width="40"  className="mx-2 d-inline-block align-text-top" />
                                {/* NUKHBA */}
                            </Link>
                        </div>
                        <div>

                            <span className="navbar-text">
                                <ul className="navbar-nav me-auto mb-2 mb-lg-0">

                                    <li className="nav-item">
                                        <a onClick={() => openRef.current.click()} style={{ cursor: 'pointer' }} className="nav-link">
                                            
                                            <img src={country == "Pakistan" ? "https://www.junaidjamshed.com/static/version1698317217/frontend/Rltsquare/junaidjamshed/en_US/Magento_Theme/images/pak-flag.png" : "https://upload.wikimedia.org/wikipedia/commons/0/0d/Flag_of_Saudi_Arabia.svg"} id="myBtn" alt="image-icon" width="30" >

                                            </img>

                                        </a>

                                    </li>
                                    <li className="nav-item">
                                        <a style={{ cursor: 'pointer' }} onClick={() => { openCart(); fetchCart() }} className="nav-link">
                                            <i style={{ fontSize: "25px", color: color }} className="fa fa-shopping-cart" aria-hidden={true}></i>

                                        </a>

                                    </li>

                                </ul>
                            </span>
                        </div>

                    </div>}
            </nav>

            {window.innerWidth > 992 && <div className='d-flex justify-content-between' style={{ borderBottom: `1px solid ${color}` }}>
                <div className="container-fluid">
                    <div>

                    </div>
                    <div>
                        <ul className="mynavbar-nav me-auto mb-2 mb-lg-0 justify-content-center">

                            {finalCategory.map((e) => {
                                return <li className="nav-item mx-5">
                                    <Link style={{ color: color }} className="nav-link active" aria-current="page" to={`categories/${e._id}`}>{e.mainHeading}</Link>
                                </li>
                            })}



                        </ul>
                    </div>
                    <div>

                    </div>
                </div>

            </div>}

            <button hidden={true} ref={ref} className="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#staticBackdrop" aria-controls="staticBackdrop">
                Toggle static offcanvas
            </button>
            {/* <Cart /> */}
        </div>
    )
}

export const fetchNavCategory = async () => {


    const urlTwo = "https://faithful-bass-yoke.cyclic.app/api/products/allproducts"
    const responseTwo = await fetch(urlTwo, {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
            "Content-Type": "application/json",
            "Accept": "*",
        },

        //   body: JSON.stringify(data), // body data type must match "Content-Type" header
    });
    const dataTwo = await responseTwo.json();


    return { navData: data, mainProducts: dataTwo }
}